import React from 'react'
import { Route, Switch, Redirect } from 'react-router-dom'
import './../App.css'
import Welcome from './Welcome'
import Color from './Color'
import Deckanchor from './Deckanchor'
import Sternanchor from './Sternanchor'
import Galley from './Galley'
import Cockpit from './Cockpit'
import Cockpit2 from './Cockpit2'
import Cockpit3 from './Cockpit3'
import Interior1 from './Interior1'
import Interior2 from './Interior2'
import Heads from './Heads'
import Summary from './Summary'
import Deckplan from './Deckplan'
import XPowerTransom from './XPowerTransom'

import Logo from './logo.svg'

import hullColor01 from '../assets/hullColors/hull_color_style_0001.jpg'
import hullColor02 from '../assets/hullColors/hull_color_style_0002.jpg'
import hullColor03 from '../assets/hullColors/hull_color_style_0003.jpg'
import hullColor04 from '../assets/hullColors/hull_color_style_0004.jpg'
import hullColor05 from '../assets/hullColors/hull_color_style_0005.jpg'
import hullColor06 from '../assets/hullColors/hull_color_style_0006.jpg'
import hullColor07 from '../assets/hullColors/hull_color_style_0007.jpg'
import hullColor08 from '../assets/hullColors/hull_color_style_0008.jpg'

import fabric01 from '../assets/fabrics/fabric_0001.jpg'
import fabric02 from '../assets/fabrics/fabric_0002.jpg'
import fabric03 from '../assets/fabrics/fabric_0003.jpg'
import fabric04 from '../assets/fabrics/fabric_0004.jpg'
import fabric05 from '../assets/fabrics/fabric_0005.jpg'

import upholstery01 from '../assets/fabrics/uph_0001.jpg'
import upholstery02 from '../assets/fabrics/uph_0002.jpg'
import upholstery03 from '../assets/fabrics/uph_0003.jpg'
import upholstery04 from '../assets/fabrics/uph_0004.jpg'

import fabric16 from '../assets/fabrics/bimini_02.jpg'

import veneer1 from '../assets/interiorColors/rosewood.jpg'
import veneer4 from '../assets/interiorColors/bleached_oak.jpg'

import brass from '../assets/interiorColors/brass.jpg'
import steel from '../assets/interiorColors/steel.jpg'

import ConfiguratorContainer from '../ConfiguratorContainer'
import { withTranslation } from 'react-i18next'

class XPowerContainer extends ConfiguratorContainer {
  constructor (props) {
    super(props)

    this.logo = Logo
    this.logoLink = 'https://www.x-yachts.com/en/powerboats/'

    this.HullColourOptions = [
      {
        value: 1,
        label: this.props.t('Pure White'),
        description: this.props.t(
          'GELCOAT (RAL 9010) & 3 x Light grey (RAL 7035) waterlines'
        ),
        preview: hullColor01
      },
      {
        value: 2,
        label: this.props.t('Red Baron'),
        description: this.props.t(
          'AWLCRAFT (RAL 3003) & 3 x White (RAL 9010) waterlines'
        ),
        preview: hullColor02
      },
      {
        value: 3,
        label: this.props.t('Petrol Blue'),
        description: this.props.t(
          'AWLCRAFT 2000 (F5476) & 3 x White (RAL 9010)  waterlines'
        ),
        preview: hullColor03
      },
      {
        value: 4,
        label: this.props.t('Aristo Blue'),
        description: this.props.t(
          'AWLCRAFT 2000 (F5010) & 3 x White 1 (RAL 9010) waterlines'
        ),
        preview: hullColor04
      },
      {
        value: 5,
        label: this.props.t('Anthracite Grey'),
        description: this.props.t(
          'AWLCRAFT 2000 (F1304) & 3 x White (RAL 9010) waterlines'
        ),
        preview: hullColor05
      },
      {
        value: 6,
        label: this.props.t('Champagne'),
        description: this.props.t(
          'AWLCRAFT 2000 (F1304) & 3 x White (RAL 9010) waterlines'
        ),
        preview: hullColor06
      },
      {
        value: 7,
        label: this.props.t('Bahia Blue Metallic'),
        description: this.props.t(
          'AWLCRAFT SE (E5004) & 3 x White (RAL 9010) waterlines'
        ),
        preview: hullColor07
      },
      {
        value: 8,
        label: this.props.t('Stone Grey Metallic'),
        description: this.props.t(
          'AWLCRAFT SE (E1006), & 3 x White (RAL 9010) waterlines'
        ),
        preview: hullColor08
      }
    ]
    this.DeckOptions = [
      { value: 1, label: this.props.t('Anti Slip - non skid surface') },
      {
        value: 2,
        label: this.props.t('Planked Flexiteek with black caulkings')
      }
    ]
    this.BiminiOptions = [
      { value: 1, label: this.props.t('Silver grey'), thumbnail: fabric16 }
    ]
    this.TTopOptions = [
      { value: 1, label: this.props.t('No T-Top') },
      { value: 2, label: this.props.t('T-Top') },
      { value: 3, label: this.props.t('T-Top with bimini') }
    ]
    this.BowOptionOptions = [
      { value: 1, label: this.props.t('None') },
      { value: 2, label: this.props.t('Cushions on deck') }
    ]
    this.UpholsteryCockpitOptions = [
      {
        value: 1,
        label: this.props.t('Silvertex Champagne'),
        thumbnail: fabric01
      },
      {
        value: 2,
        label: this.props.t('Sunbrella Capriccio Toast'),
        thumbnail: fabric02
      },
      {
        value: 3,
        label: this.props.t('Sunbrella Capriccio Grey'),
        thumbnail: fabric03
      },
      {
        value: 4,
        label: this.props.t(
          'Spradling Maglia Oak & Sunbrella Capriccio Grey Edge Details'
        ),
        thumbnail: fabric04
      },
      {
        value: 5,
        label: this.props.t(
          'Spradling Maglia Thunder & Sunbrella Capriccio Grey Edge Details'
        ),
        thumbnail: fabric05
      }
    ]
    this.EngineOptions = [
      { value: 1, label: this.props.t('Inboard engine') },
      { value: 2, label: this.props.t('Outboard engine') }
    ]
    this.AnchorSternOptions = [
      { value: 1, label: this.props.t('None') },
      { value: 2, label: this.props.t('Electrical Stern Anchor') }
    ]
    this.AnchorBowOptions = [
      { value: 1, label: this.props.t('Manual') },
      { value: 2, label: this.props.t('Retractable') }
    ]
    this.GalleyOptions = [
      { value: 1, label: this.props.t('Standard') },
      { value: 2, label: this.props.t('Optional cooling drawer') }
    ]
    this.VeneerOptions = [
      { value: 1, label: this.props.t('Rosewood'), thumbnail: veneer1 },
      { value: 4, label: this.props.t('White Tinted Oak'), thumbnail: veneer4 }
    ]
    this.FittingsOptions = [
      { value: 1, label: this.props.t('Brass'), thumbnail: brass },
      { value: 2, label: this.props.t('Steel'), thumbnail: steel }
    ]
    this.UpholsteryCabinOptions = [
      {
        value: 1,
        label: this.props.t('Just Fleckless Nature - 01'),
        thumbnail: upholstery01
      },
      {
        value: 2,
        label: this.props.t('Kvadrat Hallingdal 65 - 0143'),
        thumbnail: upholstery02
      },
      {
        value: 3,
        label: this.props.t('Kvadrat Hallingdal 65 - 0220'),
        thumbnail: upholstery03
      },
      {
        value: 4,
        label: this.props.t('Kvadrat Hallingdal 65 - 0764'),
        thumbnail: upholstery04
      }
    ]

    this.state = Object.assign(this.state, {
      boat: 'xpower',
      exterior: {
        HullColour: this.HullColourOptions[0],
        Deck: this.DeckOptions[1],
        BiminiColor: this.BiminiOptions[0],
        TTop: this.TTopOptions[0],
        BowOption: { value: 1, label: 'false' },
        UpholsteryCockpit: this.UpholsteryCockpitOptions[0],
        Engine: this.EngineOptions[0],
        AnchorStern: this.AnchorSternOptions[0],
        AnchorBow: this.AnchorBowOptions[0],
        Galley: this.GalleyOptions[0]
      },
      interior: {
        Veneer: this.VeneerOptions[0],
        Fittings: this.FittingsOptions[0],
        UpholsteryCabin: this.UpholsteryCabinOptions[0]
      },
      transom: {
        Name: {
          verticalOffset: 16,
          color: this.colorOptions[3],
          value: 'My Powerboat',
          font: this.fontOptions[0],
          size: this.sizeOptions[0],
          horizontalOffset: 0
        },
        Port: {
          verticalOffset: 75,
          color: this.colorOptions[3],
          value: 'Port',
          font: this.fontOptions[0],
          size: this.sizeOptions[1],
          horizontalOffset: 0
        },
        transom: {
          Name: {
            verticalOffset: 16,
            color: this.colorOptions[3],
            value: 'My Powerboat',
            font: this.fontOptions[0],
            size: this.sizeOptions[0],
            horizontalOffset: 0
          },
          Port: {
            verticalOffset: 75,
            color: this.colorOptions[3],
            value: 'Port',
            font: this.fontOptions[0],
            size: this.sizeOptions[1],
            horizontalOffset: 0
          }
        }
      }
    })

    this.steps = [
      { name: this.props.t('Welcome'), url: '/xpower/welcome' },
      { name: this.props.t('Color Scheme & Drivetrain'), url: '/xpower/color' },
      { name: this.props.t('Deck & bow anchor'), url: '/xpower/deckanchor' },
      { name: this.props.t('Stern Anchor'), url: '/xpower/sternanchor' },
      { name: this.props.t('Galley'), url: '/xpower/galley' },
      {
        name: this.props.t('Upholstery cockpit / deck'),
        url: '/xpower/cockpit'
      },
      { name: this.props.t('Upholstery cockpit'), url: '/xpower/cockpit2' },
      { name: this.props.t('Upholstery cockpit'), url: '/xpower/cockpit3' },
      { name: this.props.t('Deckplan'), url: '/xpower/deckplan' },
      { name: this.props.t('Transom'), url: '/xpower/transom' },
      { name: this.props.t('Interior upholstery'), url: '/xpower/interior1' },
      { name: this.props.t('Interior fittings'), url: '/xpower/Interior2' },
      { name: this.props.t('Heads'), url: '/xpower/heads' },
      { name: this.props.t('Summary'), url: '/xpower/summary' }
    ]

    this.handleHullConfigurationChange =
      this.handleHullConfigurationChange.bind(this)
  }

  handleHullConfigurationChange (newConfiguration) {
    let transom = this.state.transom
    switch (newConfiguration.HullColour.value) {
      case 1:
        break
      case 2:
        break
      case 3:
        break
      case 4:
        break
      case 5:
        break
      default:
        transom.Name.color = this.colorOptions[4]
        transom.Port.color = this.colorOptions[4]
        break
    }

    super.handleTransomChange(transom)
    super.handleExteriorConfigurationChange(newConfiguration)
  }

  componentDidMount () {
    super.componentDidMount()
    this.handleHullConfigurationChange(this.state.exterior)
  }

  generateCode () {
    let data = []
    data.push('xpower')

    data.push([])
    let exterior = this.state.exterior
    for (const key in exterior) {
      if (exterior.hasOwnProperty(key)) {
        let element = exterior[key].value
        data[data.length - 1].push(element)
      }
    }

    let transom = this.state.transom
    data.push([
      [
        transom.Name.value,
        transom.Name.font.value,
        transom.Name.size.value,
        transom.Name.color.value,
        transom.Name.horizontalOffset,
        transom.Name.verticalOffset
      ],
      [
        transom.Port.value,
        transom.Port.font.value,
        transom.Port.size.value,
        transom.Port.color.value,
        transom.Port.horizontalOffset,
        transom.Port.verticalOffset
      ]
    ])

    data.push([])
    let interior = this.state.interior
    for (const key in interior) {
      if (interior.hasOwnProperty(key)) {
        let element = interior[key].value
        data[data.length - 1].push(element)
      }
    }

    var json = JSON.stringify(data)
    return btoa(json)
  }

  parseCode (code) {
    let json = JSON.parse(atob(code))

    if (json[0] !== 'xpower') {
      return
    }

    let exterior = this.state.exterior
    exterior.HullColour =
      this.HullColourOptions.find(v => v.value === json[1][0]) ||
      this.HullColourOptions[0]
    exterior.Deck =
      this.DeckOptions.find(v => v.value === json[1][1]) || this.DeckOptions[0]
    exterior.BiminiColor =
      this.BiminiOptions.find(v => v.value === json[1][2]) ||
      this.BiminiOptions[0]
    exterior.TTop =
      this.TTopOptions.find(v => v.value === json[1][3]) || this.TTopOptions[0]
    exterior.BowOption =
      this.BowOptionOptions.find(v => v.value === json[1][5]) ||
      this.BowOptionOptions[0]
    exterior.UpholsteryCockpit =
      this.UpholsteryCockpitOptions.find(v => v.value === json[1][6]) ||
      this.UpholsteryCockpitOptions[0]
    exterior.Engine =
      this.EngineOptions.find(v => v.value === json[1][7]) ||
      this.EngineOptions[0]
    exterior.AnchorStern =
      this.AnchorSternOptions.find(v => v.value === json[1][8]) ||
      this.AnchorSternOptions[0]
    exterior.AnchorBow =
      this.AnchorBowOptions.find(v => v.value === json[1][9]) ||
      this.AnchorBowOptions[0]
    exterior.Galley =
      this.GalleyOptions.find(v => v.value === json[1][10]) ||
      this.GalleyOptions[0]

    let transom = this.state.transom
    transom.Name.value = json[2][0][0] || ''
    transom.Name.font =
      this.fontOptions.find(v => v.value === json[2][0][1]) ||
      this.fontOptions[0]
    transom.Name.size =
      this.sizeOptions.find(v => v.value === json[2][0][2]) ||
      this.sizeOptions[0]
    transom.Name.color =
      this.colorOptions.find(v => v.value === json[2][0][3]) ||
      this.colorOptions[0]
    transom.Name.horizontalOffset = +json[2][0][4] || 1
    transom.Name.verticalOffset = +json[2][0][5] || 1

    transom.Port.value = json[2][1][0] || ''
    transom.Port.font =
      this.fontOptions.find(v => v.value === json[2][1][1]) ||
      this.fontOptions[0]
    transom.Port.size =
      this.sizeOptions.find(v => v.value === json[2][1][2]) ||
      this.sizeOptions[0]
    transom.Port.color =
      this.colorOptions.find(v => v.value === json[2][1][3]) ||
      this.colorOptions[0]
    transom.Port.horizontalOffset = +json[2][1][4] || 1
    transom.Port.verticalOffset = +json[2][1][5] || 1

    let interior = this.state.interior
    interior.Veneer =
      this.VeneerOptions.find(v => v.value === json[3][0]) ||
      this.VeneerOptions[0]
    interior.Fittings =
      this.FittingsOptions.find(v => v.value === json[3][1]) ||
      this.FittingsOptions[0]
    interior.UpholsteryCabin =
      this.UpholsteryCabinOptions.find(v => v.value === json[3][2]) ||
      this.UpholsteryCabinOptions[0]

    this.setState(this.state)
  }

  renderSteps () {
    return (
      <Switch location={this.props.location}>
        <Route
          exact
          path='/xpower'
          render={() => <Redirect to='/xpower/welcome' />}
        />
        <Route
          path='/xpower/welcome'
          render={props => (
            <Welcome
              {...props}
              onChange={this.handleHullConfigurationChange}
              onCodeSubmitted={this.parseCode}
              configuration={this.state.exterior}
              transom={this.state.transom}
              hullColourOptions={this.HullColourOptions}
              TTopOptions={this.TTopOptions}
            />
          )}
        />
        <Route
          path='/xpower/color'
          render={props => (
            <Color
              {...props}
              onChange={this.handleHullConfigurationChange}
              configuration={this.state.exterior}
              transom={this.state.transom}
              hullColourOptions={this.HullColourOptions}
              TTopOptions={this.TTopOptions}
              EngineOptions={this.EngineOptions}
            />
          )}
        />
        <Route
          path='/xpower/deckanchor'
          render={props => (
            <Deckanchor
              {...props}
              onChange={this.handleExteriorConfigurationChange}
              configuration={this.state.exterior}
              DeckOptions={this.DeckOptions}
              AnchorBowOptions={this.AnchorBowOptions}
            />
          )}
        />
        <Route
          path='/xpower/sternanchor'
          render={props => (
            <Sternanchor
              {...props}
              onChange={this.handleExteriorConfigurationChange}
              transom={this.state.transom}
              configuration={this.state.exterior}
              AnchorSternOptions={this.AnchorSternOptions}
            />
          )}
        />
        <Route
          path='/xpower/galley'
          render={props => (
            <Galley
              {...props}
              onChange={this.handleExteriorConfigurationChange}
              configuration={this.state.exterior}
              GalleyOptions={this.GalleyOptions}
            />
          )}
        />
        <Route
          path='/xpower/cockpit'
          render={props => (
            <Cockpit
              {...props}
              onChange={this.handleExteriorConfigurationChange}
              configuration={this.state.exterior}
              UpholsteryCockpitOptions={this.UpholsteryCockpitOptions}
            />
          )}
        />
        <Route
          path='/xpower/cockpit2'
          render={props => (
            <Cockpit2
              {...props}
              onChange={this.handleExteriorConfigurationChange}
              configuration={this.state.exterior}
              UpholsteryCockpitOptions={this.UpholsteryCockpitOptions}
            />
          )}
        />
        <Route
          path='/xpower/cockpit3'
          render={props => (
            <Cockpit3
              {...props}
              onChange={this.handleExteriorConfigurationChange}
              configuration={this.state.exterior}
              UpholsteryCockpitOptions={this.UpholsteryCockpitOptions}
            />
          )}
        />
        <Route
          path='/xpower/interior1'
          render={props => (
            <Interior1
              {...props}
              onChange={this.handleInteriorConfigurationChange}
              configuration={this.state.interior}
              UpholsteryCabinOptions={this.UpholsteryCabinOptions}
              FittingsOptions={this.FittingsOptions}
              VeneerOptions={this.VeneerOptions}
            />
          )}
        />
        <Route
          path='/xpower/interior2'
          render={props => (
            <Interior2
              {...props}
              onChange={this.handleInteriorConfigurationChange}
              configuration={this.state.interior}
              UpholsteryCabinOptions={this.UpholsteryCabinOptions}
              FittingsOptions={this.FittingsOptions}
              VeneerOptions={this.VeneerOptions}
            />
          )}
        />
        <Route
          path='/xpower/heads'
          render={props => (
            <Heads
              {...props}
              onChange={this.handleInteriorConfigurationChange}
              configuration={this.state.interior}
              FittingsOptions={this.FittingsOptions}
              VeneerOptions={this.VeneerOptions}
            />
          )}
        />
        <Route
          path='/xpower/summary'
          render={props => (
            <Summary
              {...props}
              country={this.state.country}
              countries={this.state.countries}
              code={this.generateCode()}
              configuration={this.state}
            />
          )}
        />
        <Route
          path='/xpower/deckplan'
          render={props => (
            <Deckplan
              {...props}
              onChange={this.handleExteriorConfigurationChange}
              configuration={this.state.exterior}
              BiminiOptions={this.BiminiOptions}
            />
          )}
        />
        <Route
          path='/xpower/transom'
          render={props => (
            <XPowerTransom
              {...props}
              onChange={this.handleTransomChange}
              configuration={this.state.exterior}
              transom={this.state.transom}
              fontOptions={this.fontOptions}
              sizeOptions={this.sizeOptions}
              colorOptions={this.colorOptions}
            />
          )}
        />
      </Switch>
    )
  }
}

export default withTranslation()(XPowerContainer)



// WEBPACK FOOTER //
// ./src/Xpower/XPowerContainer.js